var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0005 15.7166L4.12265 19.0068L5.43542 12.3999L0.489929 7.82646L7.17913 7.03334L10.0005 0.916626L12.8219 7.03334L19.511 7.82646L14.5656 12.3999L15.8784 19.0068L10.0005 15.7166ZM10.0005 13.8066L13.5394 15.7875L12.749 11.8097L15.7266 9.05613L11.6992 8.57858L10.0005 4.89581L8.3018 8.57858L4.27436 9.05613L7.25195 11.8097L6.46154 15.7875L10.0005 13.8066Z",
    fill: "#6F7376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.cfe93d4369341ef9be337fb62540009b.svg";
export { ForwardRef as ReactComponent };